// import { Button } from "@mui/material";
import React from "react";
import "./SeeMoreBtn.scss";

const SeeMoreBtn = () => {
  return (
    <div className="see-more-btn see-more-btn--pri">
      <button>See More</button>
    </div>
  );
};
export default SeeMoreBtn;
